module.exports = __webpack_public_path__ + "img/20210701_172217.d7be59e5.jpg";